import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const mainMenuStyles = makeStyles((theme: Theme) => ({
    mainMenu: {
        color: theme.palette.common.white,
        scrollbarWidth: "thin",
        margin: theme.spacing(0, 1),
        height: 240,
        flexGrow: 1,
        maxWidth: 400,
        overflowY: "auto",
        "& .MuiTreeItem-root": {
            "& .MuiTreeItem-content": {
                padding: 0,
                marginBottom: theme.spacing(0),
                "&.Mui-selected $itemLabel": {
                    background: `linear-gradient(90deg, #267895 0%, #1E5D76 100%)`,
                },
                "& .MuiTreeItem-iconContainer": {
                    display: "none",
                },
                "& .MuiTreeItem-label": {
                    padding: 0,
                },
            },
        },
        // Submenu container
        "& .MuiTreeItem-group": {
            marginLeft: 0,
            "& .MuiCollapse-wrapperInner > ul, $nestedParent .MuiCollapse-wrapperInner > ul": {
                marginTop: theme.spacing(1),
                marginLeft: 0,
                padding: "1px",
                borderRadius: theme.spacing(0.5),
                boxShadow: "0px 2px 4px 0px #0000008C inset",
                background: theme.palette.button.active.from,
                "& .MuiTreeItem-root": {
                    marginBottom: 0,
                },
                // SubItems lines
                "& $indentedItem:not($topSeparator)": {
                    "&:only-child $subItemIcon": {
                        "&::before, &::after": {
                            display: "none",
                        },
                    },
                    "&:first-child $subItemIcon": {
                        "&::before": {
                            display: "none",
                        },
                    },
                    "&:last-child $subItemIcon": {
                        "&::after": {
                            display: "none",
                        },
                    },
                },
            },
        },
    },
    // Show this item as a parent (used to override the default TreeItem styles that add a box shadow and a background color)
    nestedParent: {
        boxShadow: "none !important",
        background: "transparent !important",
    },
    // Item (label and icons)
    itemLabel: {
        display: "flex",
        alignItems: "center",
        fontSize: 16,
        letterSpacing: 0.5,
        borderRadius: theme.spacing(0.5),
        "& .MuiTypography-root": {
            textAlign: "left",
        },
    },
    startIcon: {
        display: "flex",
        alignItems: "center",
        marginRight: theme.spacing(1),
    },
    endIcon: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
    },
    expandIcon: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        "& svg": {
            fontSize: 12,
        },
    },
    // Items with left padding
    indentedItem: {
        "& .Mui-selected $itemLabel": {
            background: `${theme.palette.gradients.g03.n1} !important`,
        },
    },
    // Items that change slides
    changeItem: {
        "& $itemLabel .MuiTypography-root": {
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: 1.5,
            textTransform: "uppercase",
        },
    },
    // Items that shouldn't be clickable
    disabledItem: {
        opacity: 0.5,
        pointerEvents: "none",
    },
    // SubItem (the ones with the cirle on the left)
    subItemIcon: {
        width: 16,
        height: 16,
        flex: "0 0 16px",
        borderRadius: 100,
        border: `1px solid ${theme.palette.common.white}`,
        marginRight: theme.spacing(1),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&::before, &::after": {
            content: "''",
            position: "absolute",
            height: "50%",
            borderLeft: `1px solid ${theme.palette.common.white}`,
        },
        "&::before": {
            top: 0,
        },
        "&::after": {
            bottom: 0,
        },
    },
    subItemIconDot: {
        width: 14,
        height: 14,
        borderRadius: 100,
        background: theme.palette.button.active.from,
        position: "relative",
        zIndex: 2,
    },
    subItemIconDotSelected: {
        width: 12,
        height: 12,
        background: theme.palette.common.white,
    },
    // Separators
    topSeparator: {
        borderTop: `1px solid ${theme.palette.neutrals.light}50`,
        paddingTop: theme.spacing(1),
    },
    bottomSeparator: {
        borderBottom: `1px solid ${theme.palette.neutrals.light}50`,
        paddingBottom: theme.spacing(1),
    },
}));

export default mainMenuStyles;
